module.exports = {
    templateUrl: 'news/components/case-law-links.html'
};